import MUIDataTable from 'mui-datatables'
import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { FaEdit, FaTrashAlt } from 'react-icons/fa'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { deletePackagesList, getPackagesList } from '../../../actions'
import DeleteModal from '../../../common/DeleteModal/DeleteModal'
import PackageForm from './PackageForm'

const Package = () => {

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getPackagesList())
    },[])

    const packageList = useSelector(state => state.home.packageList)
    const packages = packageList?.response?.data
    const [open, setOpen] = useState(false)

    console.log("packages", packages);
    const options = {
        filter: false,
        viewColumns: false,
        print: false,
        download: false,
        search: false,
        selectableRows: 'none',
    }

    const packageData = packages

    // Group packages under their Business Category so each category shows its
    // own block of packages (easier to scan than one long mixed list).
    const groupedPackages = (packages || []).reduce((acc, p) => {
        const key = p?.businessName || 'Other';
        if (!acc[key]) acc[key] = [];
        acc[key].push(p);
        return acc;
    }, {})

    const columns = [
        {
            name: 'name',
            label: 'Package Name',
            options: {
                filter: false,
                sort: true,
            },
        },
        {
            name: 'text',
            label: 'Description',
            options: {
                filter: false,
                sort: true,
            },
        },
        {
            name: 'businessName',
            label: 'Business Category',
            options: {
                filter: false,
                sort: true,
            },
        },
        {
            name: 'advertisementPackId',
            label: 'Advertisement Pack',
            options: {
                filter: false,
                sort: true,
            },
        },
        {
            name: 'amount',
            label: 'Amount',
            options: {
                filter: false,
                sort: true,
            },
        },
        {
            name: 'duration',
            label: 'Duration',
            options: {
                filter: false,
                sort: true,
            },
        },
        {
            name: 'currency',
            label: 'Currency',
            options: {
                filter: true,
                sort: true,
                // customBodyRender: createdAt => {
                //     return moment(createdAt).format('DD/MM/YYYY , hh:mm A');
                // },
            },
        },
        {
            name: 'status',
            label: 'Status',
            options: {
                filter: true,
                sort: true,
                customBodyRender: (status) => {
                    return (
                        <div className={(status === 'active' || status === 'ACTIVE') ? 'st-active': 'st-inactive'}>{(status === 'active' || status === 'ACTIVE') ? 'Active': 'In-Active'}</div>
                    )
                },
            },
        },
        {
            name: 'businessCode',
            label: 'businessCode',
            options: { display: false, filter: false, sort: false },
        },
        {
            name: 'advertisementPackId',
            label: 'Actions',
            options:{
                customBodyRender: (status, data) => {
                    console.log("56data", data, status);
                    return(
                        <div style={{display: 'flex', alignItems: 'center', gap: '0.4rem', cursor:'pointer'}}>
                            <FaEdit style={{fontSize: '1.4rem'}} onClick={() => onEditHandler(status, data)}/>
                            <FaTrashAlt style={{fontSize: '1.2rem'}} onClick={() => deleteHandler(status)}/>
                        </div>
                    )
                }
            }
        }
    ]

    const [dataEdit, setDataEdit] = useState({})
    const [showForm, setShowForm] = useState(false)
    const [deleteStatus, setDeleteStatus] = useState(false)
    const [deleteID, setDeleteID] = useState('')

    useEffect(() => {
        setTimeout(() => {
            dispatch(getPackagesList())
        },500)
    },[showForm])

    const deleteHandler = (delID) => {
        setDeleteID(delID)
        setOpen(true)
    }

    useEffect(() => {
        if(deleteStatus === true){
            dispatch(deletePackagesList(deleteID))
            dispatch(getPackagesList())
            setOpen(false)
        }
    },[deleteStatus])

    const onEditHandler = (advertisementPackId, editData) => {
        // Columns order: name(0) text(1) businessName(2) advertisementPackId(3)
        // amount(4) duration(5) currency(6) status(7). The first arg is the
        // Actions column value, which IS the advertisementPackId.
        setDataEdit({
            advertisementPackId: advertisementPackId,
            name: editData?.rowData?.[0],
            text: editData?.rowData?.[1],
            amount: editData?.rowData?.[4],
            duration: editData?.rowData?.[5],
            status: editData?.rowData?.[7],
            businessCode: editData?.rowData?.[8],
        })
        setShowForm(true)
    }

    const packageFormHandler = () => {
        setShowForm(true)
    }

  return (
    <div className='pcoded-inner-content'>
        <DeleteModal setOpen={setOpen} open={open} deleteStatus={setDeleteStatus}/>
        { showForm ? <PackageForm onClose={setShowForm} dataEdit={dataEdit}/> :
				<div className='main-body'>
					<div className='page-wrapper'>
						<div className='row'>
							<div className='col-sm-12'>
								<div className='card'>
                                <div className='card-block'>
                                <div className='card-header'>
										<h5>Packages</h5>
										<Link
                                            onClick={packageFormHandler}
											// to={`/products/${this.props.match.params.type}/add`}
											className='btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger'
											data-modal='modal-13'>
											<i className='icofont icofont-plus m-r-5'></i> Add Package
										</Link>
									</div>
                                    {Object.keys(groupedPackages).map((cat) => (
                                        <div key={cat} style={{ marginBottom: '1.75rem' }}>
                                            <h6 style={{ margin: '1rem 0 0.5rem', fontWeight: 600, color: '#1b2a4e' }}>{cat}</h6>
                                            <div className='dt-responsive table-responsive'>
                                                <MUIDataTable
                                                    className='table-responsive'
                                                    data={groupedPackages[cat]}
                                                    columns={columns}
                                                    options={{ ...options, pagination: false }}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>
								</div>
							</div>
						</div>
					</div>
				</div> }
			</div>
  )
}

export default Package